import { render, staticRenderFns } from "./taskPanel.vue?vue&type=template&id=2018417a&scoped=true&"
import script from "./taskPanel.vue?vue&type=script&lang=js&"
export * from "./taskPanel.vue?vue&type=script&lang=js&"
import style0 from "./taskPanel.vue?vue&type=style&index=0&id=2018417a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2018417a",
  null
  
)

export default component.exports